import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import { AppStateService } from './app-state.service';

export interface AutoLoginClinic {
  id: number;
  name: string;
  city: string;
  postalCode: string;
  hasPaymentMethod: boolean;
}

export interface AutoLoginResult {
  success: boolean;
  requiresUserDetails: boolean;
  requiresCguAcceptance?: boolean;
  requiresSccCompletion?: boolean;
  requiresClinicConfirmation?: boolean;
  userClinics?: AutoLoginClinic[];
  firstName?: string;
  lastName?: string;
}

@Injectable()
export class AuthenticationService {
  constructor( private readonly apollo: Apollo, private readonly appStateService: AppStateService) { }

  login(email: string, password: string): Observable<string> {
    return this.apollo.mutate<{ login: string }>({
      mutation : gql`mutation login($user: UserLoginDtoInput) {
        login(dto: $user)
      }`,
      variables: {
        user: {
          username: email,
          password,
          origin: this.appStateService.isScc ? 'SCC' : 'MY_PACS'
        }
      }
    }).pipe(map(res => res.data?.login ?? ''));
  }

  autoLogin(): Observable<AutoLoginResult> {
    return this.apollo.mutate<{ autoLogin: AutoLoginResult }>({
      mutation : gql`mutation autoLogin {
        autoLogin {
          success
          requiresUserDetails
          requiresCguAcceptance
        }
      }`
    }).pipe(map(res => res.data?.autoLogin ?? { success: false, requiresUserDetails: false, requiresCguAcceptance: false }));
  }

  autoLoginScc(): Observable<AutoLoginResult> {
    return this.apollo.mutate<{ autoLoginScc: AutoLoginResult }>({
      mutation : gql`mutation autoLoginScc {
        autoLoginScc {
          success
          requiresUserDetails
          requiresSccCompletion
          requiresClinicConfirmation
          userClinics { id name city postalCode hasPaymentMethod }
          firstName
          lastName
        }
      }`
    }).pipe(map(res => res.data?.autoLoginScc ?? { success: false, requiresUserDetails: false, requiresSccCompletion: false }));
  }
}
